export default __webpack_public_path__ + "static/media/554.648287c3.png";